<template>
  <v-text-field
    v-model="searchModel"
    clearable
    density="compact"
    hide-details
    variant="outlined"
    @click:clear="
      () => {
        searchModel = ''
        updateQueryString()
      }
    "
    @input="onInput"
    @keydown.enter="updateQueryString"
    @update:focused="focused = $event"
  >
    <template #append>
      <i-local-search
        v-if="!focused"
        class="cursor-pointer"
        :class="{ active: !currentSearch !== !searchModel }"
        @click="
          () => {
            emits('click-search')
            updateQueryString()
          }
        "
      />
    </template>
    <slot />
  </v-text-field>
</template>
<script setup lang="ts">
  const route = useRoute()
  const router = useRouter()
  const currentSearch = computed(() => route.query.search?.toString() ?? '')
  const searchModel = defineModel({ default: '' })
  const focused = ref(false)

  const isTyping = ref(false)
  const typingTimeout = ref<ReturnType<typeof setTimeout> | null>(null)

  const emits = defineEmits(['click-search'])

  const props = defineProps({
    defaultQuery: {
      type: Object,
      default: () => ({}),
    },
    qsEnabled: {
      type: Boolean,
      default: true,
    },
  })

  const onInput = () => {
    isTyping.value = true

    if (typingTimeout.value) clearTimeout(typingTimeout.value)

    typingTimeout.value = setTimeout(() => {
      isTyping.value = false
      updateQueryString()
    }, 600)
  }

  const updateQueryString = () => {
    if (!props.qsEnabled) return
    router.push({
      replace: searchModel.value.trim() === '',
      query: { ...route.query, ...props.defaultQuery, search: searchModel.value.trim() },
      // params: { noScrollTop: 1 },
    })
  }

  watch(
    currentSearch,
    () => {
      if (!props.qsEnabled) return
      searchModel.value = currentSearch.value
    },
    { immediate: true }
  )
</script>

<style lang="scss" scoped>
  .v-input {
    :deep(.v-input__append) {
      svg {
        opacity: 0.7;
        &.active {
          opacity: 1;
        }
      }
    }
  }
</style>
